import React from 'react'
import {SECTION_IDS} from './constants'
import EnhancementOverviewTiles from './OverviewTiles/EnhancementOverviewTiles'
import EnhancementsHoursByTypeChart from './Charts/EnhancementsHoursByTypeChart/EnhancementsHoursByTypeChart'
import Top20ByOnCallHoursTable from './Top20Tables/Top20ByOnCallHoursTable'
import Top20ByCallOutHoursTable from './Top20Tables/Top20ByCallOutHoursTable'
import Top20ProductsTable from './Top20Tables/Top20ProductsTable'
import HoursVsCallOutRatioChart from './Charts/HoursVsCallOutRatioChart/HoursVsCallOutRatioChart'
import OnTimeSubmissionChart from './Charts/OnTimeSubmissionChart/OnTimeSubmissionChart'
import SubmittedVsOverwrittenChart from './Charts/SubmittedVsOverwrittenChart/SubmittedVsOverwrittenChart'
import {EnhancementViewLevel} from './ReportViewLevelSelector'
import {PeriodType} from './PeriodTypeSelector'
import { EnhancementReportSearch } from './hooks/useEnhancementsFilter'
import { EnhancementProductStat, EnhancementReportStat } from '../../models/enhancement/enhancement-report-stats'
import { OnTimeSubmissionReport } from '../../models/enhancement/on-time-submission-report'

export interface SectionDefinition {
  id: string;
  title: string;
  isAccordion?: boolean;
  component: React.ReactNode;
}

export const getEnhancementReportSections = (
  reportData: EnhancementReportStat[],
  onTimeSubmissionData: OnTimeSubmissionReport | null,
  productData: EnhancementProductStat[],
  currentFilters: EnhancementReportSearch,
  requestTypes: string[] | undefined,
  isLoading: boolean,
  onTileClick?: (requestType: string) => void): SectionDefinition[] => {
  
  const selectedPeriodType = PeriodType.PAY_PERIOD
  
  return [
    {
      id: SECTION_IDS.OVERVIEW_TILES,
      title: 'Overview Tiles',
      component: (
        <EnhancementOverviewTiles
          reportData={reportData}
          dataTestId="EnhancementReportTab-OverviewTiles"
          selectedRequestTypes={requestTypes}
          onTileClick={onTileClick}
        />
      )
    },
    {
      id: SECTION_IDS.BY_TYPE_BY_MONTH,
      title: `By Type By ${selectedPeriodType} Chart`,
      component: (
        <EnhancementsHoursByTypeChart
          reportData={reportData}
          filterData={currentFilters}
          requestTypes={requestTypes}
          isLoading={isLoading}
          periodType={selectedPeriodType}
        />
      )
    },
    {
      id: SECTION_IDS.TOP20_ONCALL_HOURS,
      title: 'Top 20 Employees By On Call Hours',
      isAccordion: true,
      component: <Top20ByOnCallHoursTable data={reportData} selectedRequestTypes={requestTypes} />
    },
    {
      id: SECTION_IDS.TOP20_CALLOUT_HOURS,
      title: 'Top 20 Employees By Call Out Hours',
      isAccordion: true,
      component: <Top20ByCallOutHoursTable data={reportData} selectedRequestTypes={requestTypes} />
    },
    {
      id: SECTION_IDS.TOP20_PRODUCTS,
      title: 'Top 20 Products By Call Out',
      isAccordion: true,
      component: <Top20ProductsTable data={productData} selectedRequestTypes={requestTypes} />
    },    {
      id: SECTION_IDS.HOURS_VS_CALLOUT_RATIO,
      title: 'Hours vs Call Out Ratio Chart',
      component: (
        <HoursVsCallOutRatioChart
          data={reportData}
          isLoading={isLoading}
          selectedRequestTypes={requestTypes}
        />
      )
    },
    {
      id: SECTION_IDS.SUBMITTED_VS_OVERWRITTEN,
      title: 'Submitted vs Overwritten Chart',
      component: (
        <SubmittedVsOverwrittenChart
          data={reportData}
          isLoading={isLoading}
          selectedRequestTypes={requestTypes}
        />
      )
    },
    {
      id: SECTION_IDS.ONTIME_SUBMISSION,
      title: 'On Time Submission Chart',
      component: onTimeSubmissionData ? (
        <OnTimeSubmissionChart
          data={onTimeSubmissionData}
          isLoading={isLoading}
          selectedRequestTypes={requestTypes}
          periodType={selectedPeriodType}
        />
      ) : null
    }
    ]
}
